// return whether or not we are in the dev environment
export const isDev = () => {
  return !process.env.NODE_ENV || process.env.NODE_ENV === "development";
};

export const debugLog = isDev()
  ? (msg) => {
      console.log(msg);
    }
  : (msg) => {};
